import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Timetable from "./pages/Timetable";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import YouTubeRecordings from "./pages/YouTubeRecordings";
import InteriorPrayerTimes from "./pages/InteriorPrayerTimes";
import DutyRoster from "./pages/DutyRoster";
import Maintenance from "./pages/Maintenance";

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately on route change
    window.scrollTo(0, 0);
    // Also reset scroll restoration behavior
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, [pathname]);

  return null;
}

function App() {
  // Subdomain-based mount: tracker.markazrahma.org always shows the Duty Roster,
  // with the URL preserved as the subdomain (no /duty-roster suffix needed).
  if (typeof window !== 'undefined' && window.location.hostname === 'tracker.markazrahma.org') {
    return (
      <div className="App">
        <DutyRoster />
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/timetable" element={<Timetable />} />
          <Route path="/events" element={<Events />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/youtube-recordings" element={<YouTubeRecordings />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/interior-display" element={<InteriorPrayerTimes />} />
          <Route path="/duty-roster" element={<DutyRoster />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
